import React from "react";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { formatDate } from "../lib/formatters";

import { mapCardTypeToIcon } from "../lib/payment-method-type";

import navigation from "../lib/navigation-utilities";

import _ from "lodash";

const PaymentMethod = ({}) => {
  const navigateUpdate = () => {
    navigation.push("/account/profile/payment_method_update");
  };

  return (
    <Subscribe to={[ProfileContainer]}>
      {(profileContainer) => {
        const currentIdentity = profileContainer.getDetails();
        const paymentMethod = _.get(currentIdentity, "paymentMethod");

        return (
          <>
            <div className="col-sm-12">
              <div className="col-12 text-center mb-3">
                <h3>Current Card Information</h3>
              </div>
              {paymentMethod && paymentMethod.cardDetails && (
                <div className="d-flex justify-content-center py-4">
                  <div className="p-2 mr-2">
                    <span className="fa-layers fa-3x">
                      <FontAwesomeIcon
                        icon={mapCardTypeToIcon(
                          paymentMethod.cardDetails.cardType
                        )}
                      />
                    </span>
                  </div>
                  <div className="p-2">
                    <div>{paymentMethod.cardDetails.cardNumber}</div>
                    <div>
                      {formatDate(
                        paymentMethod.cardDetails.expirationDate,
                        "MM/YYYY"
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-sm-12 text-center mt-4 mb-4 pb-4">
              <button
                className="btn btn-primary btn-wide"
                onClick={navigateUpdate}
                data-target="#paymentMethodInfo">
                UPDATE
              </button>
            </div>
          </>
        );
      }}
    </Subscribe>
  );
};

export { PaymentMethod };
